import { ESectionColor, Section } from '@web_opxp/components';
import React, { FC } from 'react';
import { connect } from 'react-redux';
import { isChallengeWorkoutId } from '../../base/utils';
import { SessionSelectors } from '../../session';
import SessionProgress from '../../session/SessionProgress';
import { IState } from '../../store/state';
import IntroCarousel from '../IntroCarousel/IntroCarousel';
import * as Selectors from '../selectors';
import IntroViewChallenge from '../views/IntroViewChallenge';
import IntroViewLocked from '../views/IntroViewLocked';
import IntroViewUnlocked from '../views/IntroViewUnlocked';
import './IntroPage.scss';

export interface IIntroPageProps {
  workoutId: number;
  locked: boolean;
}

export const IntroPageFC: FC<IIntroPageProps> = ({ workoutId, locked }) => {
  const isChallengeExercise = isChallengeWorkoutId(workoutId);
  const bottomSection = locked ? <IntroViewLocked /> : <IntroViewUnlocked />;

  return (
    <>
      <Section noPadding={true} color={ESectionColor.blue} className="exercise-section">
        <div className="view intro-view">
          <IntroCarousel />
          {isChallengeExercise ? <IntroViewChallenge /> : bottomSection}
        </div>
      </Section>
      <Section>
        <SessionProgress />
      </Section>
    </>
  );
};

export const mapStateToProps = (state: IState) => {
  const workoutId = Selectors.getWorkoutId(state);
  const locked = !!SessionSelectors.isWorkoutLocked(state, workoutId);
  return {
    workoutId,
    locked,
  };
};

const IntroPage = connect(mapStateToProps)(IntroPageFC);
export default IntroPage;
